module.exports = __webpack_public_path__ + "static/media/galerija_2017 (25).e5d05ad9.jpg";